function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { ReactNode, FC, CSSProperties, Ref, RefObject } from 'react';
import cn from 'classnames';
require("./Title.css");
var styles = {
  "Root": "Title-module-Root_1B0",
  "h1Tag": "Title-module-h1Tag_9w_",
  "h2Tag": "Title-module-h2Tag_2yP",
  "h3Tag": "Title-module-h3Tag_1Y9",
  "h4Tag": "Title-module-h4Tag_jau",
  "h5Tag": "Title-module-h5Tag_2G0",
  "h6Tag": "Title-module-h6Tag_3JG",
  "thinWeight": "Title-module-thinWeight_1vd",
  "lightWeight": "Title-module-lightWeight_28r",
  "regularWeight": "Title-module-regularWeight_2Um",
  "semiBoldWeight": "Title-module-semiBoldWeight_27Q",
  "boldWeight": "Title-module-boldWeight_1ak"
};
export const TitleTags = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6'
};
export const TitleWeights = {
  thin: 'thin',
  light: 'light',
  regular: 'regular',
  semiBold: 'semiBold',
  bold: 'bold'
};
export const Title = ({
  children,
  tag = TitleTags.h1,
  weight = TitleWeights.regular,
  className,
  style,
  innerRef,
  controlRef,
  ...props
}) => {
  const Wrapper = tag;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    style: style
  }, props, {
    className: cn(styles.Root, styles[`${tag}Tag`], styles[`${weight}Weight`], className),
    ref: innerRef || controlRef
  }), children);
};
if (process.env.NODE_ENV !== 'production') {
  Title.displayName = 'Title';
}